export default __webpack_public_path__ + "static/media/img2.11ad7d44.jpg";